import request from "@/plugins/request";
import {baseApi} from "@/api/scope";

// 新增用户
export function addNews(data) {
    return request.post(baseApi, { action: 'addnews', ...data });
}

export function  getNewsList(data) {
    return request.post(baseApi, { action: 'getnewslist', ...data });
}

export function updateNews(data) {
    return request.post(baseApi, { action: 'updatenews', ...data });
}
